const MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '';

export const INSTALLER_RADIUS = 55;

export default MAP_API_KEY;
